export const MOBILE_AUTH = {
  email: 'ammar@gmail.com',
  password: '1234',
};

export const REQUEST_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected',
};

export const REQUEST_TYPE = {
  LEAVE: 'leave',
  TASK: 'task',
};

// النوع الذي عليه العلم isHourly يُطلب فيه نطاق ساعات (من ساعة إلى ساعة)
// بدلاً من نطاق تواريخ (من تاريخ إلى تاريخ).
export const mobileLeaveTypes = [
  { id: 'lv-1', name: 'إجازة سنوية' },
  { id: 'lv-2', name: 'إجازة مرضية' },
  { id: 'lv-3', name: 'إجازة أمومة' },
  { id: 'lv-4', name: 'إجازة بدون راتب' },
  { id: 'lv-5', name: 'إجازة طارئة' },
  { id: 'lv-6', name: 'إجازة ساعية', isHourly: true },
];

export const mobileTaskTypes = [
  { id: 'tk-1', name: 'مهمة عمل خارجية' },
  { id: 'tk-2', name: 'زيارة عميل' },
  { id: 'tk-3', name: 'تدريب' },
  { id: 'tk-4', name: 'اجتماع خارجي' },
  { id: 'tk-5', name: 'مهمة ميدانية' },
  { id: 'tk-6', name: 'مهمة ساعية', isHourly: true },
];

export const mobileLeaveBalance = {
  total: 100,
  used: 50,
};

// إجازة/مهمة جارية حالياً، لعرض تحذير قرب انتهائها في الواجهة الرئيسية.
// `endsInMinutes` عدد الدقائق المتبقية حتى نهايتها (يُحوّل لوقت/تاريخ فعلي عند
// الاستخدام). `isHourly` يحدّد إن كانت ساعية أم تاريخية.
export const mobileActiveAbsence = {
  type: REQUEST_TYPE.TASK,
  name: 'مهمة ساعية',
  isHourly: true,
  endsInMinutes: 45,
};

export const mobileSummary = {
  externalTasks: 3,
  sickLeaves: 2,
  sickLeavesDays: 4,
  shiftStart: '08:00',
};

export const mobileInitialRequests = [
  {
    idKey: 'req-1',
    reason: 'إذن خروج مبكر',
    type: REQUEST_TYPE.LEAVE,
    status: REQUEST_STATUS.REJECTED,
    sentAt: '12 أكتوبر 2025',
    permitDate: '15 أكتوبر 2025',
    time: '02:30 م - 04:00 م',
    durationDays: 1,
    details: 'إذن خروج مبكر لظرف عائلي.',
    rejectReason: 'لأنو رفض وبس هههههه',
    approvedBy: null,
  },
  {
    idKey: 'req-2',
    reason: 'إجازة سنوية',
    type: REQUEST_TYPE.LEAVE,
    status: REQUEST_STATUS.APPROVED,
    sentAt: '02 أكتوبر 2025',
    permitDate: '10 أكتوبر 2025',
    time: 'يوم كامل',
    durationDays: 3,
    details: 'إجازة سنوية لقضاء عطلة قصيرة.',
    rejectReason: null,
    approvedBy: 'حسام قطان',
  },
  {
    idKey: 'req-3',
    reason: 'مهمة عمل خارجية',
    type: REQUEST_TYPE.TASK,
    status: REQUEST_STATUS.PENDING,
    sentAt: '28 سبتمبر 2025',
    permitDate: '01 أكتوبر 2025',
    time: '09:00 ص - 01:00 م',
    durationDays: 1,
    details: 'زيارة عميل في موقع خارجي.',
    rejectReason: null,
    approvedBy: null,
  },
];

export const mobileInitialNotifications = [
  {
    idKey: 'ntf-1',
    title: 'تم رفض طلب الإذن',
    body: 'تم رفض طلب "إذن خروج مبكر" من قبل المدير.',
    time: 'منذ ساعتين',
    read: false,
    type: REQUEST_STATUS.REJECTED,
  },
  {
    idKey: 'ntf-2',
    title: 'تمت الموافقة على إجازتك',
    body: 'تمت الموافقة على طلب الإجازة السنوية بواسطة حسام قطان.',
    time: 'أمس',
    read: false,
    type: REQUEST_STATUS.APPROVED,
  },
  {
    idKey: 'ntf-3',
    title: 'طلبك قيد المراجعة',
    body: 'طلب المهمة الخارجية قيد المراجعة من قبل الإدارة.',
    time: 'منذ 3 أيام',
    read: true,
    type: REQUEST_STATUS.PENDING,
  },
];

export const mobileAccount = {
  username: 'ammar@gmail.com',
  password: '••••••••',
};

export const mobileEmployeeProfile = {
  name: 'وليد ريحاوي',
  employeeNumber: 115,
  department: 'الاستقبال',
  specialty: 'استقبال',
  employmentStart: '01/01/2024',
};

export const mobileAttendanceLog = [
  { idKey: 'a1', date: '28/06/2026', checkIn: '08:05 ص', checkOut: '04:10 م', status: 'late' },
  { idKey: 'a2', date: '27/06/2026', checkIn: '08:00 ص', checkOut: '04:00 م', status: 'present' },
  { idKey: 'a3', date: '26/06/2026', checkIn: '07:58 ص', checkOut: '04:02 م', status: 'present' },
  { idKey: 'a4', date: '25/06/2026', checkIn: null, checkOut: null, status: 'absent' },
  { idKey: 'a5', date: '24/06/2026', checkIn: '08:00 ص', checkOut: '04:00 م', status: 'present' },
  { idKey: 'a6', date: '23/06/2026', checkIn: '—', checkOut: '—', status: 'leave' },
];

export const mobileAttendanceSummary = {
  presentDays: 18,
  absenceDays: 2,
  lateDays: 3,
};

export const mobilePayslip = {
  month: 'حزيران 2026',
  currency: 'ل.س',
  basicSalary: 600000,
  earnings: [
    { idKey: 'e1', name: 'الراتب الأساسي', value: 600000 },
    { idKey: 'e2', name: 'بدل مواصلات', value: 50000 },
    { idKey: 'e3', name: 'الإضافي', value: 40000 },
  ],
  deductions: [
    { idKey: 'd1', name: 'تأمينات', value: 35000 },
    { idKey: 'd2', name: 'قسط سلفة', value: 50000 },
    { idKey: 'd3', name: 'خصم تأخير', value: 10000 },
  ],
};
